import { Permission } from '~/types/Permission';

import { checkIsAdmin } from './checkIsAdmin';

export const canUseRestorationHub: Permission = checkIsAdmin;
